module.exports = __webpack_public_path__ + "assets/icon-custom-component.c09ffddb.svg";